import type { ComponentSharedTracking } from '@autobid/strapi-integration/graphql/graphql'
import { getMatomo } from '@autobid/tracking/src/index'

export function trackEvent(data?: Pick<ComponentSharedTracking, 'category' | 'action' | 'name'> | null) {
  if (!data)
    return

  const matomo = getMatomo()

  if (!matomo)
    return

  const { category, action, name } = data
  matomo.trackEvent(category, action, name ?? undefined)
}
